import { useEffect, useState } from 'react'
import { TColor } from '../unifiedColorPicker.types'

export const PANTONE_COLOR_PREFIX = 'Pantone'

export const PantoneColorPicker = ({
  onChange,
  activeColor,
}: {
  activeColor: TColor
  onChange: (color: TColor) => void
}) => {
  const [pantoneCode, setPantoneCode] = useState(
    (activeColor?.value || '').replace(PANTONE_COLOR_PREFIX, '')?.trim() || ''
  )

  useEffect(() => {
    if (typeof onChange === 'function') {
      onChange(
        pantoneCode
          ? { value: `${PANTONE_COLOR_PREFIX} ${pantoneCode}`, label: '' }
          : { value: '', label: '' }
      )
    }
  }, [pantoneCode])

  return (
    <div className="flex flex-col gap-[16px]">
      <div className="w-full cursor-auto flex items-center gap-[16px] text-center border border-black-20 rounded-[6px]">
        <div className="flex-2 w-[60%] px-[16px] py-[10px] border-r border-r-black-20 leading-[20px] text-[14px] text-acai">
          Pantone Code
        </div>
        <input
          className="flex-1 w-full leading-[22px] text-[16px] py-[10px] outline-0 text-acai"
          value={pantoneCode}
          onChange={(e) => setPantoneCode(e.target.value)}
          placeholder="100"
        />
      </div>
      <div className="leading-[16px] text-[11px] text-black-60">
        <p>
          If you do not know your Pantone code, select a standard color value
          and we’ll suggest the closest matching Pantone based on your color
          value. Please note that the color on screen is not a true
          representation of the printed color.
        </p>
        <br />
        <p>
          Please refer to a{' '}
          <a
            className="underline"
            href="https://www.pantone.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Pantone library
          </a>{' '}
          or book for accuracy.
        </p>
      </div>
    </div>
  )
}
